import React from "react";
import { Slide } from "react-slideshow-image";
import "../css/Slideshow.css";
import photo from "./images/photo.jpeg";
import SimpleImageSlider from "react-simple-image-slider";

const images = [
 
  {
    url: "https://drive.google.com/uc?export=view&id=1ur0Uac_nWuIZDZU1zInc5uODtv5cc9Ue",
  },
  {
    url: "https://drive.google.com/uc?export=view&id=19tElpKTQceOd4ye4wHUl112dEs5tqkaj",
  },
];

function Slideshow() {
  return (
    <div id="slide-box">
      <div class="slider">
        <SimpleImageSlider
          width={670}
          height={350}
          images={images}
          showBullets={true}
          showNavs={true}
          autoPlay={true}
        />
      </div>

      <div class="slider-mobile">
        <SimpleImageSlider
          width={370}
          height={270}
          images={images}
          showBullets={true}
          showNavs={true}
          autoPlay={true}
        />
      </div>
    </div>
  );
}

export default Slideshow;
